"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
require("./index.scss");
const Position = ({ lg, sm, esm, style, pos, shortcut, size = 'large', }) => {
    const cN = ['ds-position'];
    if (lg)
        cN.push('is-lg');
    if (sm)
        cN.push('is-sm');
    if (esm)
        cN.push('is-extra-sm');
    const color = pos?.color;
    const name = pos?.name;
    const shortName = pos?.shortName;
    const backgroundColor = (0, util_1.isValue)(color)
        ? `#${color}`
        : '#0045ff'; // default to DS Blue
    const useShortcut = size === 'small' || shortcut;
    return (react_1.default.createElement("div", { className: 'ds-position-badge-wrapper' +
            (sm ? ' is-sm' : '') +
            (lg ? ' is-lg' : '') +
            ((0, util_1.isDefined)(size) ? ` ${size}` : '') },
        react_1.default.createElement("div", { className: cN.join(' '), style: style ? { ...style, backgroundColor } : { backgroundColor }, title: (0, maybe_unwrap_1.unwrapMaybe)(name) },
            react_1.default.createElement("div", { className: 'ds-position-name', style: {
                    color: util_1.colorUtil.contrastText(color) === 'dark' ? 'black' : 'white',
                } }, useShortcut ? shortName : name))));
};
exports.default = Position;
